<div class="container-fluid p-0">
  <app-header></app-header>
  <div class="row m-0 g-0">
    <div class="col-md-3 p-0">
      <app-folders></app-folders>
    </div>

    <div class="col-md-9 container" style="border-top-left-radius: 15px; border-top-right-radius: 15px; overflow: hidden; margin-top: 0 !important; margin-left: -7px;">
      <div class="card" style="height: 1000px">
        <div class="card-body">
          <!-- Back Button -->
          <div class="d-flex justify-content-start" style="margin-top: 0 !important">
            <button type="button" class="btn custom-button" style="margin-bottom: 10px" (click)="goBack()">
              Back
            </button>
          </div>

          <!-- Loading State -->
          <div *ngIf="loading" class="text-center">
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p>Loading form configuration...</p>
          </div>

          <!-- Error State -->
          <div *ngIf="error && !loading" class="alert alert-danger">
            {{ error }}
          </div>

          <!-- Dynamic Form -->
          <div *ngIf="formConfig && !loading && !error" class="card mt-4">
            <div class="card-header d-flex justify-content-between align-items-center">
              <h5 class="m-0">{{ formConfig.name }}</h5>
            </div>

            <div class="card-body">
              <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="form-container">
                  <!-- Dynamic Fields -->
                  <div *ngFor="let field of formConfig.fields" class="form-group" [attr.data-label]="field.title">
                    <!-- Field Label and Menu -->
                    <div class="d-flex align-items-center justify-content-between">
                      <label class="m-0">{{ field.title }}</label>
                      <div class="menu-icon" (click)="openOptionsModal($event, $event.target)" style="margin-bottom: 8px">
                        ⋮
                      </div>
                    </div>

                    <!-- Options Modal -->
                    <div class="options-modal" 
                         *ngIf="isOptionsModalOpen && fieldLabel === field.title"
                         (click)="$event.stopPropagation()"
                         style="margin-right: 50px; margin-top: -20px">
                      <div class="modal-buttons">
                        <button (click)="openModal()">Query</button>
                        <button (click)="editStudy()">Edit</button>
                        <button type="button" (click)="openReviewModal()">Review</button>
                      </div>
                    </div>

                    <!-- Field Input Based on Type -->
                    <div class="label-wrapper d-flex align-items-center justify-content-between">
                      
                      <!-- Radio Button Field -->
                      <div *ngIf="isFieldType(field, 'radio-button')" class="radio-group">
                        <label class="radio-label" *ngFor="let value of getFieldValues(field)">
                          <input type="radio" 
                                 [formControlName]="getFieldName(field.title)"
                                 [value]="value.value"
                                 [required]="field.required">
                          <span>{{ value.label }}</span>
                        </label>
                      </div>

                      <!-- Dropdown Field -->
                      <select *ngIf="isFieldType(field, 'dropdown')"
                              class="form-control"
                              [formControlName]="getFieldName(field.title)"
                              [required]="field.required">
                        <option value="">-- Select an option --</option>
                        <option *ngFor="let value of getFieldValues(field)" 
                                [value]="value.value">
                          {{ value.label }}
                        </option>
                      </select>

                      <!-- Date Field -->
                      <input *ngIf="isFieldType(field, 'date')"
                             type="date"
                             class="form-control"
                             [formControlName]="getFieldName(field.title)"
                             [required]="field.required">

                      <!-- Time Field -->
                      <input *ngIf="isFieldType(field, 'time')"
                             type="time"
                             class="form-control"
                             [formControlName]="getFieldName(field.title)"
                             [required]="field.required">

                      <!-- Number Field -->
                      <div *ngIf="isFieldType(field, 'number')" class="input-group">
                        <input type="number"
                               class="form-control"
                               [formControlName]="getFieldName(field.title)"
                               [required]="field.required">
                        <span *ngIf="getFieldUnit(field)" class="input-group-text">{{ getFieldUnit(field) }}</span>
                      </div>

                      <!-- Textarea Field -->
                      <textarea *ngIf="isFieldType(field, 'textarea')"
                                class="form-control"
                                rows="3"
                                [formControlName]="getFieldName(field.title)"
                                [required]="field.required"
                                [placeholder]="field.description"></textarea>

                      <!-- Checkbox Group Field -->
                      <div *ngIf="isFieldType(field, 'checkbox-group')" class="checkbox-group">
                        <div class="form-check" *ngFor="let value of getFieldValues(field)">
                          <input type="checkbox"
                                 class="form-check-input"
                                 [value]="value.value"
                                 [formControlName]="getFieldName(field.title)">
                          <label class="form-check-label">{{ value.label }}</label>
                        </div>
                      </div>

                      <!-- Calculated Field (Read-only) -->
                      <input *ngIf="isFieldType(field, 'calculated')"
                             type="text"
                             class="form-control"
                             [formControlName]="getFieldName(field.title)"
                             readonly>

                      <!-- Compound Field -->
                      <div *ngIf="isFieldType(field, 'compound')" class="compound-field">
                        <div *ngFor="let subField of getCompoundFields(field)" class="sub-field">
                          <label>{{ subField.title }}</label>
                          <div class="input-group">
                            <input type="number"
                                   class="form-control"
                                   [formControlName]="getFieldName(subField.title)"
                                   [required]="subField.required">
                            <span *ngIf="getFieldUnit(subField)" class="input-group-text">{{ getFieldUnit(subField) }}</span>
                          </div>
                        </div>
                      </div>

                      <!-- Signature Field -->
                      <div *ngIf="isFieldType(field, 'signature')" class="signature-field">
                        <div class="signature-pad">
                          <canvas #signatureCanvas width="400" height="200"></canvas>
                        </div>
                        <button type="button" class="btn btn-secondary btn-sm" (click)="clearSignature()">Clear</button>
                      </div>

                    </div>

                    <!-- Field Description -->
                    <small *ngIf="field.description" class="form-text text-muted">
                      {{ field.description }}
                    </small>

                    <!-- Validation Error -->
                    <div *ngIf="form.get(getFieldName(field.title))?.invalid && form.get(getFieldName(field.title))?.touched"
                         class="text-danger">
                      <small *ngIf="form.get(getFieldName(field.title))?.errors?.['required']">
                        This field is required.
                      </small>
                    </div>

                  </div>

                  <!-- PI Signature Checkbox and Submit Button -->
                  <div class="d-flex justify-content-between align-items-center mt-4">
                    <!-- PI Signature Checkbox -->
                    <div class="pi-signature-section">
                      <div class="form-check">
                        <input 
                          type="checkbox" 
                          class="form-check-input" 
                          id="piSignatureCheckbox"
                          [(ngModel)]="piSignatureReviewed"
                          name="piSignatureReviewed">
                        <label class="form-check-label fw-bold" for="piSignatureCheckbox">
                          Reviewed by PI Signature
                        </label>
                      </div>
                    </div>
                    
                    <!-- Submit Button -->
                    <button type="submit" class="btn custom-button" [disabled]="form.invalid">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <!-- Query Modal -->
          <div class="modal-overlay" *ngIf="isModalOpen">
            <div class="modal-content">
              <button class="close-btn" (click)="closeModal()">&times;</button>
              
              <!-- Tab Bar -->
              <div class="tab-bar">
                <div class="tab" 
                     *ngFor="let tab of tabs; let idx = index"
                     [class.active]="selectedTab === idx"
                     (click)="selectTab(idx)">
                  {{ tab.title }}
                </div>
                <div *ngIf="tabs[selectedTab].type === 'query'" class="add-btn-wrapper">
                  <button class="add-btn" (click)="addQuery(0)">+</button>
                  <span class="add-query-tooltip">Add Query</span>
                </div>
              </div>

              <!-- Modal Body -->
              <div class="modal-body">
                <ng-container [ngSwitch]="tabs[selectedTab].type">
                  <!-- Query Tab -->
                  <div *ngSwitchCase="'query'">
                    <div *ngFor="let query of queries; let i = index" class="query-box">
                      <div class="input-checkbox-container">
                        <input type="text"
                               class="form-control"
                               [value]="query.text"
                               (input)="query.text = $event.target.value"
                               [readonly]="query.isClosed"
                               [ngClass]="{ 'query-closed': query.isClosed }"
                               placeholder="Enter your query">
                      </div>

                      <!-- Audit Trail -->
                      <div class="audit-trail">
                        <h4>Audit Trail</h4>
                        <div class="audit-entry" *ngFor="let entry of query.auditTrail">
                          <strong>{{ entry.user }}</strong> - {{ entry.timestamp | date:'dd-MMM-yyyy h:mm a' }}
                          <p>{{ entry.message }}</p>
                        </div>
                      </div>

                      <div class="modal-footer">
                        <button class="btn custom-button"
                                [ngClass]="{ 'btn-disabled': query.isClosed }"
                                (click)="!query.isClosed && confirmCloseQuery(i)">
                          Close
                        </button>
                        <button class="btn custom-button ms-2"
                                (click)="confirmSubmitQuery(i)"
                                [disabled]="query.isClosed">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Field History Tab -->
                  <div *ngSwitchCase="'fieldHistory'">
                    <div *ngIf="fieldHistoryData?.length > 0; else noData">
                      <div *ngFor="let entry of fieldHistoryData" class="history-box">
                        <div class="history-header">
                          <strong>{{ entry.updated_by }}</strong> - {{ entry.updated_at | date:'medium' }}
                        </div>
                        <div class="history-value">{{ entry.value }}</div>
                        <div class="edit-reason" *ngIf="entry.edit_reason">
                          <em>Reason for change: {{ entry.edit_reason }}</em>
                        </div>
                      </div>
                    </div>
                    <ng-template #noData>
                      <p>No history available for this field.</p>
                    </ng-template>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>

          <!-- Review Modal -->
          <div class="modal-overlay1" *ngIf="showReviewModal" (click)="closeReviewModal()">
            <span class="close-button1" (click)="closeReviewModal()">×</span>
            <div class="modal-content1" (click)="$event.stopPropagation()">
              <div class="checkbox-group">
                <div class="form-check" style="margin-top: 20px">
                  <input type="checkbox"
                         id="reviewedByDataMonitor"
                         name="reviewedByDataMonitor"
                         [(ngModel)]="reviewOptions.dataMonitor"
                         (change)="onReviewCheckboxChange()">
                  <label for="reviewedByDataMonitor">Reviewed by Data Manager</label>
                </div>
              </div>
              <div class="checkbox-group">
                <div class="form-check">
                  <input type="checkbox"
                         id="reviewedByMonitor"
                         name="reviewedByMonitor"
                         [(ngModel)]="reviewOptions.monitor"
                         (change)="onReviewCheckboxChange()">
                  <label for="reviewedByMonitor">Reviewed by Monitor</label>
                </div>
              </div>
              <div class="checkbox-group">
                <div class="form-check">
                  <input type="checkbox"
                         id="reviewedByPI"
                         name="reviewedByPI"
                         [(ngModel)]="reviewOptions.pi">
                  <label for="reviewedByPI">Reviewed by PI</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Edit Reason Modal -->
          <div class="modal-overlay" *ngIf="isReasonModalOpen">
            <div class="modal-content">
              <button class="close-btn" (click)="cancelEditReason()">×</button>
              <h4>Please provide a reason for editing:</h4>
              <textarea class="form-control"
                        [(ngModel)]="editReason"
                        rows="4"
                        placeholder="Enter reason here..."></textarea>
              <div class="modal-footer">
                <button class="btn custom-button" (click)="confirmEditReason()">Confirm</button>
                <button class="btn custom-button" (click)="cancelEditReason()">Cancel</button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
